import { useContext } from "react";

import { MultiSelectButtonContext } from "~/contexts/multi-select-button";

export const useMultiSelectButton = () => useContext(MultiSelectButtonContext);
